export default [
  {
    label: 'Módulo I',
    title: 'Carne de Sol',
    body:
      'A Carne de Sol e os processos que a tornam a principal proteína da região. Além de nove técnicas, estão incluídas neste módulo as receitas do rubacão, tartar de carne de sol e capitão de feijão verde.',
    totalPrice: 'R$ 399,00',
    price: 'R$ 99,90',
    action: {
      target: '_blank',
      href:
        'https://pay.hotmart.com/O18292656P?checkoutMode=0&bid=1592951688877',
      label: 'Comprar',
      color: 'primary',
    },
  },
  {
    label: 'Combo II & III',
    title: 'Milho & Macaxeira',
    body:
      'Adquira acesso aos2 novos módulos – MILHO & MACAXEIRA – por um preço especial e garanta 14 Videoaulas com técnicas e pratos que vão fazer você enxergar a Cozinha Nordestina com outros olhos.',
    totalPrice: 'R$ 499,00',
    price: 'R$ 189,90',
    action: {
      target: '_blank',
      href:
        'https://pay.hotmart.com/N37277066I?checkoutMode=0&bid=1593475180852',
      label: 'Comprar',
      color: 'primary',
    },
  },
  {
    label: 'Módulo II',
    title: 'Milho',
    body:
      'A macaxeira é a versatilidade em forma de raiz. Seu uso segue cada vez mais explorado, descoberto e apreciado. Aqui estão quatro técnicas e as receitas do terrine de rabada, mil folhas de macaxeira e lasanha de macaxeira.',
    totalPrice: 'R$ 399,00',
    price: 'R$ 99,90',
    action: {
      target: '_blank',
      href:
        'https://pay.hotmart.com/U37454050V?checkoutMode=0&bid=1594169647607',
      label: 'Comprar',
      color: 'primary',
    },
  },
  {
    label: 'Módulo III',
    title: 'Macaxeira',
    body:
      'O milho é o único cereal nativo do Brasil. Seu nome é munguzá, xerém, mingau e uma infinidade de outras coisas. Aprenda três técnicas e receitas de costela no bafo, munguzá de carne e munguzá de frutos do mar.',
    totalPrice: 'R$ 399,00',
    price: 'R$ 99,90',
    action: {
      target: '_blank',
      href:
        'https://pay.hotmart.com/J37459012E?checkoutMode=0&bid=1594169631849',
      label: 'Comprar',
      color: 'primary',
    },
  },
]
